import { useState, type ReactNode } from 'react';
import { Checkbox, Text } from '@mantine/core';
import { PrivacyNoticeModal } from './PrivacyNoticeModal';
import { useCopy } from '@/lib/settings';
import '@/styles/flows.css';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Override the sentence (default: copy key consent.data_text). */
  label?: ReactNode;
  /** Show "Read the privacy notice" (opens it in a sheet) under the box. */
  withNoticeLink?: boolean;
  required?: boolean;
}

/** POPIA consent (copy key consent.data_text) with the privacy notice one tap away. */
export function ConsentCheckbox({ checked, onChange, label, withNoticeLink = true, required = true }: Props) {
  const [open, setOpen] = useState(false);
  const { t } = useCopy();
  return (
    <div>
      <Checkbox
        checked={checked}
        onChange={(e) => onChange(e.currentTarget.checked)}
        required={required}
        styles={{ body: { alignItems: 'flex-start' }, label: { paddingInlineStart: 10 } }}
        label={<Text size="md" component="span">{label ?? t('consent.data_text')}</Text>}
      />
      {withNoticeLink && (
        <div style={{ paddingInlineStart: 34 }}>
          <button type="button" className="rides-linkbtn" onClick={() => setOpen(true)}>Read the privacy notice</button>
        </div>
      )}
      <PrivacyNoticeModal opened={open} onClose={() => setOpen(false)} />
    </div>
  );
}
